import {
  transition,
  style,
  state,
  animate,
  AnimationTransitionMetadata,
  AnimationStateMetadata,
} from '@angular/animations';
import { styleVariables } from '../../styles/variables';
import {
  AnimationResult,
  AnimationService,
} from '../../core/ui/animation.service';

export const pgExpandableCardTransitionBackdrop = [
  state(
    'expanded',
    style({
      opacity: 0.8,
      visibility: 'visible',
      'z-index': 15,
    })
  ),
  state(
    '*',
    style({
      opacity: 0,
      visibility: 'hidden',
      'z-index': 0,
    })
  ),
  transition('* => expanded', [
    style({
      visibility: 'visible',
      'z-index': 15,
    }),
    animate(`150ms ${styleVariables.transitionCurveStandard}`),
  ]),
  transition('expanded => *', [
    style({
      visibility: 'visible',
      'z-index': 15,
    }),
    animate(`150ms ${styleVariables.transitionCurveStandard}`),
  ]),
];

export function createCollapseAnimationPromises(
  animationService: AnimationService,
  cardEl: HTMLElement,
  contentEl: HTMLElement,
  cardBoundingBox: ClientRect,
  targetBounds: {
    width: number;
    height: number;
    left: number;
    top: number;
  },
  duration: number
): Promise<AnimationResult[]>[] {
  return [
    animationService.animate({
      targets: cardEl,
      width: [`${cardBoundingBox.width}px`, `${targetBounds.width}px`],
      height: [`${cardBoundingBox.height}px`, `${targetBounds.height}px`],
      transform: `translate(${targetBounds.left}px, ${targetBounds.top}px)`,
      duration: duration,
      delay: 100,
      easing: styleVariables.transitionCurveStandard,
      fillMode: 'forwards',
    }),
    animationService.animate({
      targets: contentEl,
      opacity: [1, 0],
      duration: duration,
      delay: 0,
      transform: [`translateY(0px)`, `translateY(16px)`],
      easing: styleVariables.transitionCurveStandard,
      fillMode: 'forwards',
    }),
  ];
}

export function createExpandAnimationPromises(
  animationService: AnimationService,
  cardEl: HTMLElement,
  contentEl: HTMLElement,
  cardBoundingBox: ClientRect,
  targetBounds: {
    width: number;
    height: number;
    left: number;
    top: number;
  },
  duration: number
): Promise<AnimationResult[]>[] {
  return [
    animationService.animate({
      targets: cardEl,
      width: `${targetBounds.width}px`,
      transform: [
        `translate(${cardBoundingBox.left}px, ${cardBoundingBox.top}px)`,
        `translate(${targetBounds.left}px, ${targetBounds.top}px)`,
      ],
      height: targetBounds.height,
      duration: duration,
      delay: 0,
      easing: styleVariables.transitionCurveStandard,
      fillMode: 'forwards',
    }),
    animationService.animate({
      targets: contentEl,
      opacity: [0, 1],
      duration: duration - 50,
      delay: 150,
      transform: [`translateY(16px)`, `translateY(0px)`],
      easing: styleVariables.transitionCurveStandard,
      fillMode: 'forwards',
    }),
  ];
}
